<template>
  <div>
    <div style="padding-top: 87px; padding-bottom: 108px">
      <mytitle title="研发及生产工艺" FiexText="R & D PROCESS"></mytitle>
    </div>
    <div class="research">
      <div class="researchcontent">
        <div class="researchBox1">
          <div class="researchBox1text">
            BAILICHUN护肤品配⽅采⽤超纯⽔为载体，⾼⼭⽕绒草为等渗体，超低分⼦量携带专利功效成分、直达细胞线粒体（细胞动力工厂）经呼吸作用产生能量，直达病灶、针对治疗。
          </div>
          <img
            src="../../assets/img/research/3.png"
            alt=""
            style="width: 560px;height:350px"
          />
        </div>
        <div class="researchBox2">
          <img
            src="../../assets/img/research/2.png"
            alt=""
            style="width: 1180px"
          />
        </div>
        <div style="height:138px"></div>
        <div class="researchBox1">
          <img
            src="../../assets/img/research/1.png"
            alt=""
            style="width: 560px;height:350px"
          />
          <div class="researchBox1text">
            生产采用高标准生产工艺，洁净无尘车间、全自动无菌灌装。严格按照化妆品生产质量管理规范进行生产，确保产品安全品质。
          </div>
        </div>
         <div style="height:158px"></div>
      </div>
    </div>

    <div>
      <foolerBar></foolerBar>
    </div>
  </div>
</template>

<script>
import mytitle from "../../components/title.vue";

import foolerBar from "../../components/foolerBar.vue";
export default {
  components: {
    foolerBar,
    mytitle,
  },
  methods: {},
  data() {
    return {
      imgData: [
        require("@/assets/img/homePage/banner.jpg"),
        require("@/assets/img/homePage/banner(1).jpg"),
        require("@/assets/img/homePage/banner(2).jpg"),
        require("@/assets/img/homePage/banner(3).jpg"),
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.research {
  display: flex;
  justify-content: center;
  .researchcontent {
    width: 1180px;
    .researchBox1 {
      display: flex;
      justify-content: space-between;
      .researchBox1text {
        width: 568px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #666666;
        line-height: 48px;
        margin-top: 24px;
      }
    }
    .researchBox2 {
      margin-top: 138px;
    }
  }
}
</style>>


